var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",style:({ width: _vm.locWidth, height: _vm.locHeight })},[(!_vm.staticCall)?_c('div',[(
        !_vm.staticCall && _vm.svgData !== null && _vm.locHeight !== 0 && _vm.locWidth !== 0
      )?_c('div',{staticClass:"svg-box",style:({
        width: _vm.locWidth,
        height: _vm.locHeight,
        overflow: 'hidden'
      }),domProps:{"innerHTML":_vm._s(_vm.svgData)}}):_vm._e()]):_vm._e(),(_vm.staticCall)?_c('div',{staticClass:"svg-box",style:({ width: _vm.locWidth, height: _vm.locHeight })},[(
        _vm.staticCall && _vm.svgUrl !== null && _vm.locHeight !== 0 && _vm.locWidth !== 0
      )?_c('img',{style:({ width: _vm.locWidth, height: _vm.locHeight }),attrs:{"src":_vm.svgUrl}}):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }